import { useMemo } from 'react';

import { useIsNetworkAdminEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useNetworkAdminPageSettings: UseMainUIFeatureSettings<'networkAdminPage'> = (options) => {
  const networkAdminPageOverrides = options?.overrides?.networkAdminPage;

  const isNetworkAdminEnabled = useIsNetworkAdminEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isNetworkAdminEnabled,
      ...networkAdminPageOverrides,
    }),
    [networkAdminPageOverrides, isNetworkAdminEnabled]
  );
};
